import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import propertyImprovementsListAction from './propertyImprovementsList.action.json' with { type: 'json' }
import { propertyImprovementsObject } from '../propertyImprovementsObject'

export const propertyImprovementsExpression = expression(propertyImprovementsObject.shape)

const propertyImprovementsListDefinition = defineAction({
  ...propertyImprovementsListAction,

  input: z.object({
    filter: propertyImprovementsExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      improvementType: 'Tipo de benfeitoria',
      quantity: 'Quantidade',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(propertyImprovementsObject),
    count: z.number(),
  }),
})

export default propertyImprovementsListDefinition
